import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../../../contexts/AuthContext";
import { usePricings } from "./usePricings";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../../../../shared/config";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";

export const useSummaryAndAdjust = () => {
  const {
    state: { participant },
  } = useContext(ProcessContext);

  const {
    state: { agent },
  } = useContext(AuthContext);

  const { quota_selection_by_borrower_is_allowed } = agent;

  const { requestGetPricingByLoanId } = usePricings();

  const ALLOWED_PARTICIPANT_ROLES_FOR_ADJUSTING_LOAN_TERM = [
    ONBOARDING_PARTICIPANT_ROLES.BORROWER,
  ];

  const isCurrentParticipantAllowedToAdjustLoanTerm =
    ALLOWED_PARTICIPANT_ROLES_FOR_ADJUSTING_LOAN_TERM.some(
      (role) => role === participant.role
    );

  useEffect(() => {
    if (
      quota_selection_by_borrower_is_allowed === true &&
      isCurrentParticipantAllowedToAdjustLoanTerm
    ) {
      requestGetPricingByLoanId();
    }
  }, []);
};
